<form [formGroup]="formGroupInput()">
  <div class="card">
    <div class="card-header">
      {{
        "registrationWizard.proofOfProfessionalStatusForm.proofOfStatus"
          | translate
      }}
    </div>
    <div class="card-body">
      <label class="mb-2">{{
        "registrationWizard.proofOfProfessionalStatusForm.clerify" | translate
      }}</label>
      <label class="mb-2">{{
        "registrationWizard.proofOfProfessionalStatusForm.info" | translate
      }}</label>
      <label class="mb-2">{{
        "registrationWizard.proofOfProfessionalStatusForm.provingDocument"
          | translate
      }}</label>
      @if (proofOfProfessionalStatusForm) {
        <app-upload-files
          [title]="''"
          [formControls]="proofOfProfessionalStatusForm"
          [canAdd]="false"
        ></app-upload-files>
      }
    </div>
  </div>
</form>
